import { PurchaseConfirmModal } from '@/components/PurchaseConfirmModal';
import { useLocale } from '@/context/LocaleContext';

interface BuyTagModalProps {
  open: boolean;
  tag: string;
  price: number;
  balance: number | null;
  balanceLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  confirming?: boolean;
}

export function BuyTagModal({
  open,
  tag,
  price,
  balance,
  balanceLoading,
  onConfirm,
  onClose,
  confirming,
}: BuyTagModalProps) {
  const { t } = useLocale();

  return (
    <PurchaseConfirmModal className="silk-modal--aaa"
      open={open}
      headerTitle={t('tm_buy_tag_modal_title')}
      price={price}
      balance={balance}
      balanceLoading={balanceLoading}
      confirming={confirming}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <p className="tm-buy-modal-extra">
        <strong>{t('tm_buy_tag_label')}</strong>{' '}
        <span className="tm-buy-modal-tag-preview">{tag}</span>
      </p>
    </PurchaseConfirmModal>
  );
}
